import React from 'react';
import moment from 'moment';
import {
  useHistory
} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';
import { Divider } from '@material-ui/core';
import { CheckCircleRounded } from '@material-ui/icons';

import Config from './config';
import Logo from './assets/logo.png';
import { checkMobileNumber, formatMobileNumber } from './utils';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  header: {
    textAlign: 'center',
  },
  form: {
    '& > *': {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    textAlign: 'center',
    minWidth: 280,
    maxWidth: 340,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(4),

  },
  formControl: {
    width: 300,
    backgroundColor: '#FFF',
  },
  otpButton: {
    color: '#666',
    marginTop: theme.spacing(1),
    backgroundColor: '#FFF',
  },
  button: {
    width: 300,
    height: 56,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
    // color: 'white',
    fontSize: 18,
  },
  title: {
    fontSize: 40, marginBottom: 50, marginTop: 50
  },
  logo: {
    marginBottom: theme.spacing(2),
    height: 80,
    marginTop: theme.spacing(6),
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const [mobile, setMobile] = React.useState<string>('');
  const [verifyCode, setVerifyCode] = React.useState<string>();
  const [count, setCount] = React.useState(0);
  const [isRunning, setIsRunning] = React.useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>();
  const [sentPasswordCompleted, setSentPasswordCompleted] = React.useState<boolean>(false);


  const handleSubmit = () => {
    if (!mobile || !verifyCode) {
      setErrorMessage('Please enter all required information');
      setSnackbarOpen(true);
      return;
    }

    if (!checkMobileNumber(mobile.trim())) {
      setErrorMessage('Please enter a valid mobile number');
      setSnackbarOpen(true);
      return;
    }
    retrievePassword();
  };

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const retrievePassword = async () => {
    try {
      const res = await fetch(`${Config.apiUrl}account/manage/forget-password`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            otp: verifyCode || '',
          },
          body: JSON.stringify({
            mobile: formatMobileNumber(mobile.trim()),
          })
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      // setErrorMessage('Submit successfully! Passowrd has been sent to your mobile.');
      // setSnackbarOpen(true);
      setSentPasswordCompleted(true)
    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };

  const handleSendVerifyCode = async () => {
    const checkMobile = checkMobileNumber(mobile.trim());
    if (!checkMobile) {
      setErrorMessage('Please enter valid mobile number');
      setSnackbarOpen(true);
      return;
    }
    try {
      const res = await fetch(`${Config.apiUrl}account/manage/otp-request/mobile`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            mobile: formatMobileNumber(mobile.trim()),
          })
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      setErrorMessage('Sent successfully! Verify Code has been sent to your mobile.');
      setSnackbarOpen(true);
      setCount(30);
      setIsRunning(true);
    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };

  useInterval(() => {
    setCount(count - 1);
    if (count === 0) setIsRunning(false);
  }, isRunning ? 1000 : null);


  return (
    <div className={classes.root}>
      <Container className={classes.header}>
        <img alt="guestbook.linkpos.com.au" src={Logo} className={classes.logo} />

        <Typography variant="h2" component="h2" style={{ fontSize: 28, marginBottom: 30 }}>
          Retrieve Password
          </Typography>
        <Divider />
      </Container>
      {sentPasswordCompleted ?
        <div className={classes.form}>
          <CheckCircleRounded htmlColor='#0DDD7E' style={{ fontSize: 150, marginBottom: 20, marginTop: 30, }} />
          <Typography variant="h6" component="p" style={{ color: 'black', marginTop: 20, marginBottom: 20 }} >
            Submit successfully!
          </Typography>
          <Typography variant="body2" component="p" style={{ color: 'black', marginTop: 20, marginBottom: 20 }} >
            Passowrd has been sent to your mobile.
          </Typography>
          <Button
            onClick={() => history.push('/login')}
            variant="contained"
            color="primary"
            disableElevation
            // size="large"
            className={classes.button}
          >
            Login
          </Button>
        </div>
        : null}
      {!sentPasswordCompleted ?
        <div className={classes.form}>
          <TextField
            color="secondary"
            type="number"
            fullWidth
            className={classes.formControl}
            autoComplete="tel"
            required id="mobile"
            label="Mobile"
            variant="outlined"
            value={mobile}
            onChange={e => setMobile(e.target.value)}
          />
          <TextField
            color="secondary"
            type="number"
            fullWidth
            className={classes.formControl}
            // autoComplete="tel"
            required id="verifyCode"
            label="Verify Code"
            variant="outlined"
            value={verifyCode}
            onChange={e => setVerifyCode(e.target.value)}
          />
          <Button className={classes.otpButton} disabled={count > 0} onClick={handleSendVerifyCode} variant="outlined" >
            {count > 0 && `(${count}) `}Get Verification Code
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disableElevation
            size="large"
            className={classes.button}
          >
            Retrieve Password
        </Button>
          <Typography variant="caption" component="p" style={{ textAlign: 'center', marginTop: 10, }} >
            © {moment().format('YYYY')} Link Tech, Inc. All rights reserved.
        </Typography>
        </div>
        : null}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};

function useInterval(callback: Function, delay: any) {
  const savedCallback = React.useRef<any>();

  // Remember the latest function.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default ForgotPassword;